import { PageOrderEnum } from "@/lib/enum/pageOrder.enum";
import thgService from "@/services/thg/services/thgService";
import { ThgThgControllerFindAllPaginatedParamsGen, ThgThgViewModelGen } from "@/services/thg/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, getModule, Module } from "vuex-module-decorators";
import { BasePagination } from "./base-pagination.store";

@Module({
  dynamic: true,
  namespaced: true,
  name: "thgPagination",
  store
})
export class ThePaginationStore extends BasePagination<ThgThgViewModelGen, ThgThgControllerFindAllPaginatedParamsGen> {
  protected _pageOrder: PageOrderEnum = PageOrderEnum.DESCENDING;
  protected _itemsPerPage = 500;
  protected _totalPages = 0;
  protected _paginationList: ThgThgViewModelGen[] = [];
  protected _currentPage = 1;
  protected _totalItems = 0;
  protected _isLoadAll = false;

  @Action
  protected async loadDocuments(query: any): Promise<any> {
    return thgService.getAllThgsPaginated(query);
  }
}

export const ThgPaginationModule = getModule(ThePaginationStore);
